<template>
  <div :title="allDate" class="date">{{ shortCreationDate }}</div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'BookmarkDate',
  props: ['creationDate', 'updateDate'],
  components: {}
})
class BookmarkDate extends Vue {
  @Prop creationDate
  @Prop updateDate

  get shortCreationDate() {
    let d = new Date(this.creationDate)
    return `${d.getFullYear()}/${this.padding0(d.getMonth() + 1)}/${this.padding0(d.getDate())}`
  }

  padding0(number) {
    if (number <= 9) {
      return '0' + number
    }
    return number
  }

  get allDate() {
    let c = new Date(this.creationDate)
    let result = `created at ${c.toString()}`
    if (this.updateDate) {
      let u = new Date(this.updateDate)
      result += `\nupdated at ${u.toString()}`
    }
    return result
  }
}

export default BookmarkDate
</script>
